import { jsx as _jsx } from "react/jsx-runtime";
import { useRef } from "react";
const Popover = ({ isOpen, onMouseEnter, onMouseLeave, children, theme = "light", className = "", transitionStatus = "open", }) => {
    const popoverRef = useRef(null);
    const isDark = theme === "dark";
    if (!isOpen)
        return null;
    return (_jsx("div", { onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, className: `text-base p-8 rounded-2xl border shadow-lg max-w-[300px] absolute z-[7000] w-[300px] top-full end-0 mt-1 origin-top opacity-0 ${transitionStatus === "open"
            ? "animate-selectPopoverEnter"
            : "animate-selectPopoverExit"} ${isDark ? "bg-colorBaseGray850 border-gray-700" : "bg-white border-gray-200"} 
      ${className}`, ref: popoverRef, "aria-label": "popover", "data-transition-status": transitionStatus, "data-placement": "bottom", children: children }));
};
export default Popover;
//# sourceMappingURL=Popover.js.map